/* global ga, NProgress */
Wee.fn.make('common', {
	init: function() {
		var scope = this,
			$priv = scope.$private,
			$main = $('ref:navWrap'),
			$body = $($._body),
			loadingClass = '-page-is-loading',
			loadTimer = null;

		$.view.addHelper('greater', function(number) {
			return this.val.length > number;
		});

		// Init hero parallax
		$priv.initHero();
		$priv.scrollToHash();

		NProgress.configure({
			showSpinner: false
		});

		// Init PJAX + history
		$.history.init({
			bind: {
				click: 'a:not(.exclude)'
			},
			partials: 'title, main',
			begin: function() {
				$main.addClass(loadingClass);
			},
			request: {
				send: function(e) {
					NProgress.start();

					loadTimer = setInterval(function() {
						NProgress.inc();
					}, 600);
				},
				complete: function() {
					clearInterval(loadTimer);
					NProgress.done();
				}
			},
			end: function() {
				$main.removeClass(loadingClass);
				$body.removeClass('-menu-showing');
				$priv.scrollToHash(40);

				if (typeof ga !== 'undefined') {
		            ga('set', 'page', Wee.routes.uri().full);
		            ga('send', 'pageview');
		        }
			},
			error: function(xhr) {
				$._win.location = xhr.responseURL;
	   		}
		});

		// Disable mouse event outlines
		$('a').on('mousedown', function() {
			var $el = $(this);

			if ($el.css('outline-style') == 'none') {
				var outlineClass = '-no-outline';

				$el.addClass(outlineClass).on('blur', function() {
					$el.removeClass(outlineClass);
				}, {
					once: true
				});
			}
		}, {
			delegate: Wee._body
		});
	},

	/**
	 * Remove a hash anchor link from the URL bar
	 */
	removeHash: function() {
		var loc = window.location,
			scrollV,
			scrollH;

		if ('pushState' in history) {
			history.pushState('', document.title, loc.pathname + loc.search);
		} else {
			scrollV = $._body.scrollTop;
			scrollH = $._body.scrollLeft;
			loc.hash = '';
			$._body.scrollTop = scrollV;
			$._body.scrollLeft = scrollH;
		}
	}
}, {
	/**
	 * Check for hash in url and smoothly scroll to position
	 */
	scrollToHash: function(offset) {
		var hash = $.routes.uri().hash,
			$el = $('#' + hash);
		offset = offset || 70;

		if (hash && $el.length) {
			Wee.animate.tween($._body, {
				scrollTop: ($el.offset().top + -offset) + 'px'
			});
		}
	},

	/**
	 * Initialize hero parallax scrolling and video
	 */
	initHero: function() {
		var scope = this;
		scope.$target = $('ref:hero');
		scope.$targetContainer = $('.hero');

		if (scope.$target.length) {
			$($._win).on('scroll', function() {
				var scroll = $._win.pageYOffset;

				if (scroll < 800 && scroll > 0) {
					var shift = (scroll / 6) + 'px';

					scope.$target.css('transform', 'translateY(' + shift + ')');
					scope.$targetContainer.css('margin-top', '-' + shift);
				}
			});
		}
	}
});
